export const MEDIA_QUERY = {
    ONLY_XS: '(max-width: 639px)',

    FROM_SM: '(min-width: 640px)',
    ONLY_SM: '(min-width: 640px) and (max-width: 767px)',
    UPTO_SM: '(max-width: 767px)',

    FROM_MD: '(min-width: 768px)',
    ONLY_MD: '(min-width: 768px) and (max-width: 1023px)',
    UPTO_MD: '(max-width: 1023px)',

    FROM_LG: '(min-width: 1024px)',
    ONLY_LG: '(min-width: 1024px) and (max-width: 1279px)',
    UPTO_LG: '(max-width: 1279px)',

    FROM_XL: '(min-width: 1280px)',
    ONLY_XL: '(min-width: 1280px) and (max-width: 1535px)',
    UPTO_XL: '(max-width: 1535px)',

    ONLY_XXL: '(min-width: 1536px)',
};
